import { MOTIVE_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useMotiveList } from './hook';
import { MotiveListProps } from './props';

export const MotiveList = ({ filters }: MotiveListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useMotiveList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            autoAdjustHeight
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(
                    `${MOTIVE_DETAIL}/${encodeURIComponent(item.row.name)}/${
                        item.row.active
                    }`,
                    '_blank'
                )
            }
        />
    );
};
